(function () {
	const initCollapsibleContent = () => {
		$(".collapsible-content-summery")
			.unbind("click")
			.on("click", function () {
				const $currentSummary = $(this);
				const $parentItem = $currentSummary.closest(
					".collapsible-content-item"
				);
				const $section = $currentSummary.closest(".collapsible-content-box");

				const isCurrentlyActive = $parentItem.hasClass("active");

				$section
					.find(".collapsible-content-item.active")
					.removeClass("active")
					.find(".collapsible-content-block__description")
					.stop()
					.slideUp(300);
				$section.find(".collapsible-content-summery").attr("aria-expanded", "false");

				if (!isCurrentlyActive) {
					$parentItem.addClass("active");
					$currentSummary.attr("aria-expanded", "true");
					$currentSummary
						.next(".collapsible-content-block__description")
						.stop()
						.slideDown(300);
				}
			});

		// The summaries are role="button" divs, so Enter and Space must toggle them too.
		$(".collapsible-content-summery")
			.off("keydown.pgAccordion")
			.on("keydown.pgAccordion", function (event) {
				if (event.key === "Enter" || event.key === " ") {
					event.preventDefault();
					$(this).trigger("click");
				}
			});
	};

	document.addEventListener("shopify:section:load", function () {
		initCollapsibleContent();
	});

	document.addEventListener("DOMContentLoaded", function () {
		initCollapsibleContent();
	});
})();
